import { InputChangeEventDetail } from '@ionic/react';

export enum LabelPosition {
  STACKED = 'stacked',
  FLOATING = 'floating',
}

export type FieldItemProps = {
  value: string | number;
  onIonChange: (event: CustomEvent<InputChangeEventDetail>) => void;
  name: string;
  hasError?: boolean;
};
